import React from 'react';
import filter from 'lodash/filter';
import { SunburstPoint } from 'react-vis';
import { getTotal } from 'app/components/Charts/sunburst/common/tooltip/utils';
import {
  tooltipcss,
  tooltiprowcss,
} from 'app/components/Charts/sunburst/common/tooltip/styles';
import { useRecoilValue } from 'recoil';
import { transactionTypeAtom } from 'app/state/recoil/atoms';

interface SunburstTooltipProps {
  hoveredNode: SunburstPoint | null;
}

export const SunburstTooltip = (props: SunburstTooltipProps) => {
  const [renderedChildren, setRenderedChildren] = React.useState<JSX.Element[]>(
    []
  );
  const transactionType = useRecoilValue(transactionTypeAtom);
  React.useEffect(() => {
    const children = props.hoveredNode ? props.hoveredNode.children : [];
    if (children) {
      setRenderedChildren(
        filter(
          children.map((child: SunburstPoint) => ({
            ...child,
            total: getTotal(child, true),
          })),
          (child: any) => child.total > 0
        ).map((child: any) => (
          <div key={child.title} css={tooltiprowcss(false, '#626262')}>
            <div>{child.title}</div>
            <div>{child.total}</div>
          </div>
        ))
      );
    } else {
      setRenderedChildren([]);
    }
  }, [props.hoveredNode]);

  return props.hoveredNode ? (
    <div css={tooltipcss} id="sunburst-tooltip">
      <div css={tooltiprowcss(true, '#d1d1d1')}>
        <div>Sector</div>
        <div>{transactionType.name}</div>
      </div>
      <div css={tooltiprowcss(true, '#2e4063')}>
        <div>{props.hoveredNode.title}</div>
        <div>{getTotal(props.hoveredNode, true)}</div>
      </div>
      {renderedChildren.length > 0 && renderedChildren}
    </div>
  ) : null;
};
